import {floatNumber, toLocaleLowerCase, toLocaleTitleCase, toLocaleUpperCase} from '@/app-core/lib/helpers'
import LangSwitch from '@/app-theme/components/widgets/LangSwitch.vue'
import CartCommon from '@/app-core/mixins/cart/cartCommon'

export default {
  name      : 'AppToolbar',
  components: {LangSwitch},
  directives: {},
  mixins    : [CartCommon],
  props     : {
    navigationDrawer: {
      type   : Boolean,
      default: undefined
    },
    logo: {
      type   : Boolean,
      default: true
    },
    langSwitch: {
      type   : Boolean,
      default: false
    },
    cart: {
      type   : Boolean,
      default: false
    },
    account: {
      type   : Boolean,
      default: false
    },
    height: {
      type   : [String, Number],
      default: 68
    }
  },
  dataStore: {
    AppCart: 'App.Cart'
  },
  data() {
    return {
      accountMenu    : null,
      userMenuVisible: false
    }
  },
  computed: {
    title() {
      const key = `Route.${this.$route.name}.Title`
      return this.$te(key) ? this.$t(key) : this.$t('Common.App.Title')
    },

    navigationDrawerVisible: {
      get() {
        return this.navigationDrawer
      },
      set(val) {
        this.$emit('update:navigationDrawer', val)
      }
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    toLocaleUpperCase,
    toLocaleTitleCase,
    toLocaleLowerCase,
    floatNumber,

    onLoginClick() {
      this.$bus.$emit('login:show-dialog')
    },

    onLogoutClick() {
      this.logout()
    },

    onRegisterClick() {
      this.$bus.$emit('register:show-dialog')
    }
  }
}
